import { ComponentProps } from 'react';

import { Link, Text } from '@chakra-ui/react';

export const HelpCenterMessage: React.FC<ComponentProps<typeof Text>> = (props) => {
	return (
		<Text {...props}>
			For information about managing due dates and making individual student exceptions, visit the{' '}
			<Link
				href="https://instructorhelp.soomolearning.com/en/collections/3687199-due-dates"
				isExternal>
				Due Dates collection
			</Link>{' '}
			in our Help Center.
		</Text>
	);
};
